import { Form, FormItemProps, Select, SelectProps } from "antd";
import { FunctionComponent } from "react";

export type SelectFormItemProps = SelectProps & FormItemProps & {
    testid?: string;
};

export const SelectFormItem: FunctionComponent<SelectFormItemProps> = ({ name, label, rules, testid, ...rest }) => {

    return (
        <Form.Item name={name.split(".")} label={label} rules={rules}>
            <Select {...rest} {...({ testid: testid ?? name } as any)} />
        </Form.Item>
    );
}